import JEN_HowSFWork_Animation from '@/assets/animation/JEN_HowSFWork-Animation_Web--v04.json';
import { AppleIcon, InstagramIcon, SpotifyIcon, WavesIcon } from '@/components/Icons';
import { Button } from '@/components/ui/button';
import Lottie from 'lottie-react';

export function Profile({
  playerCardRef,
  trackListRef,
}: {
  playerCardRef: React.RefObject<HTMLDivElement>;
  trackListRef: React.RefObject<HTMLDivElement>;
}) {
  return (
    <div className="flex flex-col gap-8 items-stretch">
      <div className="flex justify-between lg:flex-row gap-20 items-center mt-24">
        {/* Left Column */}
        <div className="w-[400px]">
          <h1 className="text-[2.15rem] font-normal leading-[120%] tracking-[-0.32px]">Imogen Heap</h1>

          <p className="mt-4 text-[1.25rem] leading-[1.5rem] tracking-[-0.32px] text-[#48484B]">
            A 30-year career of self-produced music, four solo albums, Frou Frou, and collaborations with Taylor Swift, Deadmau5, and more.
          </p>

          <div className="mt-6 flex gap-6">
            <a href="https://music.apple.com/us/artist/imogen-heap/22873602" className="opacity-70 hover:opacity-100 transition-colors">
              <AppleIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
            </a>
            <a
              href="https://open.spotify.com/artist/6Xb4ezwoAQC4516kI89nWz?si=edsWHMlnT0qQwEWY1RL-ZQ"
              className="opacity-70 hover:opacity-100 transition-colors"
            >
              <SpotifyIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
            </a>
            <a href="https://www.instagram.com/imogenheap/" className="opacity-70 hover:opacity-100 transition-colors">
              <InstagramIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
            </a>
            <a href="https://tidal.com/browse/artist/3475" className="opacity-70 hover:opacity-100 transition-colors">
              <WavesIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
            </a>
          </div>

          {/* <div className="mt-6 text-[0.8rem] flex flex-col sm:flex-row gap-6">
            <button className="group text-left text-[0.75rem] font-normal">
              <span className="inline-flex text-[#48484B] items-center gap-2 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:text-jen-orange">
                <span
                  className="underline text-[14px] tracking-[-4%] leading-[120%]"
                  onClick={() => {
                    if (playerCardRef?.current) {
                      playerCardRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  Read Bio
                </span>
              </span>
            </button>
            <button className="group text-left text-[0.75rem] font-normal">
              <span className="inline-flex  text-[#48484B] items-center gap-2 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:text-jen-orange">
                <span
                  className="underline text-[14px] tracking-[-4%] leading-[120%]"
                  onClick={() => {
                    if (trackListRef?.current) {
                      trackListRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  StyleFilter™ Generated Tracks
                </span>
              </span>
            </button>
          </div> */}
        </div>

        {/* Right Column */}
        <div className="w-[432px]">
          <div className="space-y-4">
            <div className="w-full max-w-3xl mx-auto p-4 bg-[#fff] rounded-3xl">
              <div className="flex items-center justify-between">
                <h2 className="font-medium">How StyleFilters™ Work</h2>
                <Button
                  variant="link"
                  onClick={() => {
                    window.open('https://jenmusic.ai/stylefilters', '_blank');
                  }}
                >
                  <span className="text-[#9D9DA6] hover:text-gray-700 underline">Learn More</span>
                </Button>
              </div>

              <div className="h-auto w-[400px] mt-4">
                <Lottie animationData={JEN_HowSFWork_Animation} className="w-full h-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
